module.exports = __webpack_public_path__ + "static/media/nc-logo.954b32ab.svg";